/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:b10ad6c9-0b50-40fb-ae7a-6dd4007a6c71",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_qZzja4zpX",
    "aws_user_pools_web_client_id": "3f8jtqgkb1kjk8ranckjjt8du5",
    "oauth": {
        "domain": "streamline973df640-973df640-dev.auth.eu-west-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.dev.streamline-media.net/",
        "redirectSignOut": "https://app.dev.streamline-media.net/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "delic-user-content-storage-stage133011-dev",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
